import React, { FC } from 'react';
import cls from 'classnames';
import { NavChipProps } from './NavChip.types';
import {
	getClassNames,
	getRootClassListFromProps,
} from '../../../../utilities/classNames';
import { useNavContext } from '../../../../utilities/useNavContext';

export const classNames = getClassNames('sds-nav-chip', ['container', 'is-selected']);

const selectedColor = 'text-primary';
const defaultColor = 'text-onSurface';

const NavChip: FC<NavChipProps> = (props) => {
	const { LinkComponent: Link } = useNavContext();
	const { className, title, Icon, isSelected, onClick, to, target } = props;

	return (
		<Link
			className={cls(getRootClassListFromProps(classNames, props), className)}
			to={to}
			onClick={onClick}
			aria-label={`Navigate to ${title}`}
			target={target}
		>
			<div className={classNames.container}>
				<Icon size="XS" color={isSelected ? selectedColor : defaultColor} />
				{title}
			</div>
		</Link>
	);
};

NavChip.displayName = 'NavChip';

export default NavChip;
